import { mapGetters } from '~/assets/javascript/modules/vuex';

export const useRecordPage = (routeName: string) => {
  const route = useRoute();
  const { $store, $router, $localePath } = useNuxtApp();
  const { sortedIds, recordToolbox } = mapGetters($store, 'recordList', ['sortedIds', 'recordToolbox']);
  const { isViewInsideStepper } = mapGetters($store, 'viewsMenu', ['isViewInsideStepper']);

  const recordIndex = computed(() => sortedIds.value.indexOf(route.params.recordId));
  const lastRecordIndex = computed(() => sortedIds.value.length - 1);
  const insideStepper = computed(() => isViewInsideStepper.value(route.params.viewId));
  const hasNext = computed(() => recordIndex.value < lastRecordIndex.value);
  const hasPrevious = computed(() => recordIndex.value > 0);
  const previousRecordId = computed(() => (recordIndex.value > 0 ? sortedIds.value[recordIndex.value - 1] : undefined));
  const nextRecordId = computed(() => (recordIndex.value < lastRecordIndex.value ? sortedIds.value[recordIndex.value + 1] : undefined));

  function goToRecord(recordId: string) {
    $router.push($localePath({
      name: routeName,
      params: {
        tenantSlug: route.params.tenantSlug,
        viewId: route.params.viewId,
        recordId,
      },
    }));
  }

  return {
    recordId: computed(() => route.params.recordId),
    record: computed(() => recordToolbox.value.findRecord(route.params.recordId)),
    insideStepper,
    exodiaProps: computed(() => ({
      attrs: {
        showPreviousBtn: insideStepper.value ? false : hasPrevious.value,
        showNextBtn: insideStepper.value ? false : hasNext.value,
        navigationDirection: 'horizontal',
      },
      on: insideStepper.value ? {} : {
        onPreviousBtnClick: () => {
          goToRecord(previousRecordId.value);
        },
        onNextBtnClick: () => {
          goToRecord(nextRecordId.value);
        },
      },
    })),
  };
};
